module.exports = __webpack_public_path__ + "static/img/mall.b6649b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/wallet/mall.jpg
// module id = 178
// module chunks = 17 18